module.exports = __webpack_public_path__ + "img/z- (5)_Moment.b4f2c45c.jpg";